import { getEnv } from "@bkry/bowline-utils";
const ETH = {
  name: "Ether",
  symbol: "ETH",
  decimals: 18,
};

const MATIC = {
  name: "Matic",
  symbol: "MATIC",
  decimals: 18,
};

const CELO = {
  name: "Celo",
  symbol: "CELO",
  decimals: 18,
};

function isExtendedChainInformation(chainInformation) {
  return !!chainInformation.isExtended;
}

export function getAddChainParameters(chainId, extended = false) {
  const chainInformation = CHAINS[chainId];
  if (
    extended ||
    (chainInformation && isExtendedChainInformation(chainInformation))
  ) {
    return {
      chainId,
      chainName: chainInformation.name,
      nativeCurrency: chainInformation.nativeCurrency || ETH,
      rpcUrls: chainInformation.urls,
      blockExplorerUrls: chainInformation.blockExplorerUrls,
      chainHex: chainInformation.chainHex,
    };
  } else {
    return chainId;
  }
}
const getInfuraUrlFor = (network) =>
  getEnv("REACT_APP_INFURA_ID")
    ? `https://${network}.infura.io/v3/${getEnv("REACT_APP_INFURA_ID")}`
    : undefined;

// const getAlchemyUrlFor = (network) =>
//   process.env.alchemyKey
//     ? `https://${network}.alchemyapi.io/v2/${getEnv("REACT_APP_ALCHEMY_ID")}`
//     : undefined;

export const MAINNET_CHAINS = {
  1: {
    urls: [getInfuraUrlFor("mainnet"), "https://cloudflare-eth.com"].filter(
      Boolean
    ),
    name: "Ethereum Mainnet",
    apiName: "ethereum",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://etherscan.io"],
    chainHex: "0x1",
    isExtended: false,
  },
  // Optimism
  10: {
    urls: [
      getInfuraUrlFor("optimism-mainnet"),
      "https://mainnet.optimism.io",
    ].filter(Boolean),
    name: "Optimism",
    apiName: "optimism",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://optimistic.etherscan.io"],
    chainHex: "0xa",
    isExtended: true,
  },
  // Arbitrum
  42161: {
    urls: [
      getInfuraUrlFor("arbitrum-mainnet"),
      "https://arb1.arbitrum.io/rpc",
    ].filter(Boolean),
    name: "Arbitrum One",
    apiName: "arbitrum",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://arbiscan.io"],
    chainHex: "0xA4B1",
    isExtended: true,
  },
  // Polygon
  137: {
    urls: [
      getInfuraUrlFor("polygon-mainnet"),
      "https://polygon-rpc.com",
    ].filter(Boolean),
    name: "Polygon Mainnet",
    apiName: "polygon",
    nativeCurrency: MATIC,
    blockExplorerUrls: ["https://polygonscan.com"],
    chainHex: "0x89",
    isExtended: true,
  },
  42220: {
    urls: ["https://forno.celo.org"],
    name: "Celo",
    apiName: "celo",
    nativeCurrency: CELO,
    blockExplorerUrls: ["https://explorer.celo.org"],
    chainHex: "0xa4ec",
    isExtended: false,
  },
};

export const TESTNET_CHAINS = {
  3: {
    urls: [getInfuraUrlFor("ropsten")].filter(Boolean),
    name: "Ropsten",
    apiName: "ropsten",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://ropsten.etherscan.io"],
    chainHex: "0x3",
    isExtended: false,
  },
  4: {
    urls: [getInfuraUrlFor("rinkeby")].filter(Boolean),
    name: "Rinkeby",
    apiName: "rinkeby",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://rinkeby.etherscan.io"],
    chainHex: "0x4",
    isExtended: false,
  },
  5: {
    urls: [getInfuraUrlFor("goerli")].filter(Boolean),
    name: "Görli",
    apiName: "goerli",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://goerli.etherscan.io"],
    chainHex: "0x5",
    isExtended: false,
  },
  42: {
    urls: [getInfuraUrlFor("kovan")].filter(Boolean),
    name: "Kovan",
    apiName: "kovan",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://kovan.etherscan.io"],
    chainHex: "0x2A",
    isExtended: false,
  },
  69: {
    urls: [
      getInfuraUrlFor("optimism-kovan"),
      "https://kovan.optimism.io",
    ].filter(Boolean),
    name: "Optimism Kovan",
    apiName: "optimism_kovan",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://kovan-optimistic.etherscan.io"],
    chainHex: "0x45",
    isExtended: true,
  },
  420: {
    urls: [
      getInfuraUrlFor("optimism-goerli"),
      "https://goerli.optimism.io",
    ].filter(Boolean),
    name: "Optimism Goerli",
    apiName: "optimism_goerli",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://goerli-explorer.optimism.io"],
    chainHex: "0x1A4F",
    isExtended: true,
  },
  421613: {
    urls: [
      getInfuraUrlFor("arbitrum-goerli"),
      "https://goerli-rollup.arbitrum.io/rpc",
    ].filter(Boolean),
    name: "Arbitrum Goerli",
    apiName: "arbitrum_goerli",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://testnet.arbiscan.io"],
    chainHex: "0x66EEA",
    isExtended: true,
  },
  44787: {
    urls: ["https://alfajores-forno.celo-testnet.org"],
    name: "Celo Alfajores",
    apiName: "celo_alfajores",
    nativeCurrency: CELO,
    blockExplorerUrls: ["https://alfajores-blockscout.celo-testnet.org"],
    chainHex: "0xa4ec",
    isExtended: false,
  },
  421611: {
    urls: [
      getInfuraUrlFor("arbitrum-rinkeby"),
      "https://rinkeby.arbitrum.io/rpc",
    ].filter(Boolean),
    name: "Arbitrum Testnet",
    apiName: "arbitrum_testnet",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://testnet.arbiscan.io"],
    chainHex: "0x66EEB",
    isExtended: true,
  },
  80001: {
    urls: [
      getInfuraUrlFor("polygon-mumbai"),
      // "https://rpc-mumbai.maticvigil.com",
      "https://polygon-mumbai-bor-rpc.publicnode.com",
    ].filter(Boolean),
    name: "Polygon Mumbai",
    apiName: "mumbai",
    nativeCurrency: MATIC,
    blockExplorerUrls: ["https://mumbai.polygonscan.com"],
    chainHex: "0x13881",
    isExtended: true,
  },
  // Amoy
  80002: {
    urls: [
      getInfuraUrlFor("polygon-amoy"),
      "https://rpc-amoy.polygon.technology/",
    ].filter(Boolean),
    name: "Amoy",
    apiName: "amoy",
    nativeCurrency: MATIC,
    blockExplorerUrls: ["https://amoy.polygonscan.com/"],
    chainHex: "0x13882",
    isExtended: true,
  },
  // Sepolia
  11155111: {
    urls: [getInfuraUrlFor("sepolia")].filter(Boolean),
    name: "Sepolia",
    apiName: "sepolia",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://sepolia.etherscan.io"],
    chainHex: "0xAA36A7",
    isExtended: true,
  },
};

// env vars set as constants only work in the browser, not in ssr. For this reason we need to do this ugly repetition of getEnv
export const CHAINS = {
  ...MAINNET_CHAINS,
  ...TESTNET_CHAINS,
};

export const URLS = Object.keys(CHAINS).reduce((accumulator, chainId) => {
  const validURLs = CHAINS[Number(chainId)].urls;

  if (validURLs.length) {
    accumulator[Number(chainId)] = validURLs;
  }

  return accumulator;
}, {});

export const chainIdToHex = (chainId) => {
  return CHAINS[chainId]?.chainHex;
};
